import { useMutation } from "react-query";

import { buildFormDataPayload } from "../../helpers/api";
import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type RequestDossierVehiclePricingPayload = {
  requestedExteriorColour: string;
  requestedInteriorColour: string;
  driverVehicleQuoteFile: File | null;
};

export const requestDossierVehiclePricing = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: RequestDossierVehiclePricingPayload
    ): Promise<string> => {
      return fetchWithAuth<string>("requestDossierVehiclePricing", dossierId, {
        requestOptions: {
          method: "post",
          body: buildFormDataPayload(payload, ["driverVehicleQuoteFile"]),
          excludeContentTypeHeader: true,
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled([["dossier", dossierId]]),
  });
};
